import React, { useMemo } from 'react';
import Modal from '../../../ui/modal/Modal';
import Button, { ButtonThemes } from '../../../ui/button/Button';
import styles from './HelpDeskSuccessDialog.module.scss';
import { Icon } from '../../../ui/icon/Icon';
import { Icons } from '../../../ui/icon/icons/material';
import { IconStyles } from '../../../ui/icon/Icon.types';
import runtimeConfig from '../../../config/runtimeConfig';

export type HelpDeskSuccessDialogProps = {
    isOpen: boolean;
    onClose: () => void;
    caseNumber?: string | null;
};

export const buildHelpDeskCaseUrl = (caseNumber?: string | null) => {
    const baseUrl = `${runtimeConfig.powerSourceUrl}/my-requests`;
    const trimmedCaseNumber = caseNumber?.trim();

    return trimmedCaseNumber ? `${baseUrl}/${encodeURIComponent(trimmedCaseNumber)}` : baseUrl;
};

const HelpDeskSuccessDialog: React.FC<HelpDeskSuccessDialogProps> = ({ isOpen, onClose, caseNumber }) => {
    const caseUrl = useMemo(() => buildHelpDeskCaseUrl(caseNumber), [caseNumber]);

    const header = useMemo(
        () => (
            <div className={styles.header}>
                <Icon.Base title={'Help'} iconName={Icons.check} iconStyle={IconStyles.filled} className={styles.icon} />
                <div className={styles.title}>Case Created Successfully!</div>
            </div>
        ),
        [],
    );

    const body = (
        <div className={styles.body}>
            {!!caseNumber?.trim() && <p className={styles.caseNumber}>Case number: {caseNumber}</p>}
            <p className={styles.message}>Thank you for creating a support case. You will receive an email notification when our support team responds.</p>
            <p className={styles.message}>
                You can follow your case in the AI assistant under{' '}
                <a
                    href={caseUrl}
                    target="_blank"
                    rel="noreferrer"
                    className={styles.link}
                >
                    view case
                </a>
                .
            </p>
        </div>
    );

    const footer = (
        <div className={styles.footer}>
            <Button theme={ButtonThemes.primary} onClick={onClose}>
                OK
            </Button>
        </div>
    );

    return (
        <Modal
            className={styles.successDialog}
            isOpen={isOpen}
            header={header}
            body={body}
            footer={footer}
            onClose={onClose}
            closeOnBackdropClick
            closeOnEscape
        />
    );
};

export default HelpDeskSuccessDialog;
